import { computed, Ref, ref } from "@vue/composition-api";

export const UseRef = <T>(
  seed: T
): [Readonly<Ref<Readonly<T>>>, (new_val: T) => void, () => void] => {
  const val: Ref<T> = ref(seed);
  const read_only_val = computed(() => val.value);
  const set_val = (new_val: T) => {
    val.value = new_val;
  };
  const reset = () => {
    val.value = seed;
  };

  return [read_only_val, set_val, reset];
};

export const UseObjRef = <T>(
  seed: T,
  is_valid: (t: T) => boolean
): {
  val: Readonly<Ref<Readonly<T>>>;
  set_prop: <K extends keyof T>(prop: K, new_val: T[K]) => void;
  reset: () => void;
  is_valid: Readonly<Ref<Readonly<boolean>>>;
} => {
  const val: Ref<T> = ref({ ...seed });
  const read_only_val = computed(() => val.value);
  const set_prop = <K extends keyof T>(prop: K, new_val: T[K]) => {
    val.value = {
      ...val.value,
      [prop]: new_val,
    };
  };
  const reset = () => {
    val.value = seed;
  };

  return {
    val: read_only_val,
    set_prop,
    reset,
    is_valid: computed(() => is_valid(val.value)),
  };
};

export type AsSetValue<T> = T & { is_set: boolean };

export const UseRefSet = <T>(
  seed: T,
  init_is_set: boolean,
  is_set: (t: T) => boolean
): [
  Readonly<Ref<Readonly<AsSetValue<T>>>>,
  (new_val: T) => void,
  () => void
] => {
  const val: Ref<T & { is_set: boolean }> = ref({
    ...seed,
    is_set: init_is_set,
  });
  const read_only_val = computed(() => val.value);
  const set_val = (new_val: T) => {
    val.value = { ...new_val, is_set: is_set(new_val) };
  };
  const reset = () => {
    val.value = { ...seed, is_set: init_is_set };
  };

  return [read_only_val, set_val, reset];
};
